import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { useNetwork } from '../composables/useNetwork'

interface BannerOfflineProps {
  /** For logging */
  // dataTest: string
  /** Quasar color, any other overrides */
  classProps?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BannerOffline',
  props: {
    classProps: { default: 'bg-warning' }
  },
  setup(__props: any) {

const props = __props

const { getStatus } = useNetwork()

const bannerRef = ref()

return (_ctx: any,_cache: any) => {
  const _component_q_banner = _resolveComponent("q-banner")!

  return (!_unref(getStatus))
    ? (_openBlock(), _createBlock(_component_q_banner, _mergeProps({
        key: 0,
        "inline-actions": "",
        class: "text-black bg-warning q-mb-md",
        ref_key: "bannerRef",
        ref: bannerRef
      }, props), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16))
    : _createCommentVNode("", true)
}
}

})